module.exports = __webpack_public_path__ + "fonts/iconfont.c9aea364.woff";